import { render } from "./kakaoAth.vue?vue&type=template&id=5304204b"
import script from "./kakaoAth.vue?vue&type=script&lang=js"
export * from "./kakaoAth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__